import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client'
import { HttpLink } from '@apollo/client/link/http'
import { onError } from '@apollo/client/link/error'

import { API_AUTH_OPTIONS, getAuthRedirectUrl } from './environment'

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_API_ROOT,
  ...API_AUTH_OPTIONS,
})

const errorLink = onError(({ networkError }) => {
  // if API call fails due to authentication error, redirect to login page
  if (networkError && networkError.statusCode === 401) {
    window.location = getAuthRedirectUrl()
  }
})

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([errorLink, httpLink]),
})

apolloClient.defaultOptions = {
  query: {
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
}

export default apolloClient
